import { Search, PenTool, Rocket, LineChart } from "lucide-react";

const steps = [
  {
    id: "diagnose",
    icon: Search,
    label: "Diagnose",
    desc: "We understand your organisation, team structure, challenges and objectives.",
  },
  {
    id: "design",
    icon: PenTool,
    label: "Design",
    desc: "We create a tailored training or consulting solution aligned with your goals.",
  },
  {
    id: "deliver",
    icon: Rocket,
    label: "Deliver",
    desc: "We deliver through in-person, online or blended learning formats.",
  },
  {
    id: "develop",
    icon: LineChart,
    label: "Develop",
    desc: "We support long-term capability building, adoption and measurable improvement.",
  },
];

export default function Approach() {
  return (
    <section
      id="approach"
      data-testid="approach-section"
      className="relative py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 lg:px-16">
        <div className="max-w-3xl reveal">
          <span className="eyebrow">Our Approach</span>
          <h2
            data-testid="approach-headline"
            className="font-display mt-4 text-4xl md:text-5xl lg:text-[56px] leading-[1.05] text-slate-900"
          >
            Tailored training built around your{" "}
            <span className="text-orange-600">organisation</span>.
          </h2>
          <p className="mt-5 text-[17px] leading-relaxed text-slate-600 max-w-[620px]">
            A proven four-stage process that turns business priorities into
            measurable capability.
          </p>
        </div>

        <div className="mt-16 relative">
          {/* Connecting line */}
          <div className="hidden lg:block absolute top-12 left-[8%] right-[8%] h-[2px] bg-gradient-to-r from-orange-500/0 via-orange-500/60 to-orange-500/0" />

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {steps.map((s, i) => {
              const Icon = s.icon;
              return (
                <div
                  key={s.id}
                  data-testid={`approach-step-${s.id}`}
                  className="relative reveal"
                  style={{ transitionDelay: `${i * 80}ms` }}
                >
                  <div className="relative size-24 mx-auto rounded-full bg-white border border-slate-900/10 flex items-center justify-center shadow-[0_18px_30px_-18px_rgba(15,23,42,0.25)]">
                    <Icon
                      className="size-9 text-orange-600"
                      strokeWidth={1.4}
                    />
                    <span className="absolute -top-2 -right-2 size-7 rounded-full bg-slate-900 text-white text-[12px] font-bold flex items-center justify-center">
                      {i + 1}
                    </span>
                  </div>
                  <div className="mt-6 text-center">
                    <h3 className="font-display text-2xl text-slate-900">
                      {s.label}
                    </h3>
                    <p className="mt-3 text-[15px] leading-relaxed text-slate-600 max-w-xs mx-auto">
                      {s.desc}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
